import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';

export const generatePartner = createProvider(api.createPartner)
  .andThen((res) => res)
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      console.warn('Fetch list aborted');
    } else {
      console.error('Fetch list was failed:', error);
    }
    throw error;
  });
